import { FinancialCategory } from 'src/financial/financial-data/hooks/useFinancialItems';

const categoryToItemNoun: Record<FinancialCategory, string> = {
  SPENDING_ACCOUNT: 'spending account',
  ASSET: 'asset',
  LIABILITY: 'liability',
  PROTECTION: 'protection policy',
};

/** Names the kind of item being added in a sentence, as "asset" or "protection policy". */
export const financialItemNoun = (category: FinancialCategory | undefined): string =>
  category ? categoryToItemNoun[category] : 'item';
